

import React, { useState, useEffect, useRef } from 'react';
import { convertUTCToLocalDateTime } from '../../../../components/dateTime';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
  IconButton,
  Button,
  useMediaQuery,
  InputBase,
  Pagination,
  Menu,
  MenuItem
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import CustomText, { textStyles } from '../../../../components/CustomText';
import tablefilter from '../../../../assets/tablefilter.svg';
import AddCompanyDrawer from './AddClientsDrawer';
import InviteDetails from './ClientsDetails';
import ExportInvitesPDF from './invitesPDF';
import { pdf } from '@react-pdf/renderer';
import FilterDrawer from './FilterDrawer';
import StatusDropdown from '../../../../components/StatusDropdown';
import ExportDropdown from '../../../../components/ExportDropdown';
import { BASE_URL } from '../../../../components/BaseUrl';
import { Toaster, toast } from 'react-hot-toast';
import { decryptToken } from "../../../../Utlis/Encryption";
import countryList from 'react-select-country-list';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setCompanyAdmins } from '../../../../Redux/Slices/CompanyAdminSlices';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import NorthIcon from '@mui/icons-material/North'; // Ascending
import SouthIcon from '@mui/icons-material/South';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import back from "../../../../assets/back.svg";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowStatusDropdown from "../../../../components/ArrowStatusDropdown";
import ExportInvitesExcel from "./InvitesExcel";
import InvitedClientsPins from "./InvitedClientsPins"

const ManageInvitesTable = () => {
  const [tableProcessing, setTableProcessing] = useState(false);

  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [tableRows, setTableRows] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [statusUpdating, setStatusUpdating] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortLoading, setSortLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [verifyingId, setVerifyingId] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard || false;
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    subscription_plan: '',
    subscription_status: '',
    status: '',
    verification_status: '',
    start_date: '',
    end_date: '',
    country: '',
    province: '',
    city: '',
  });

  const INITIAL_FILTERS = {
    subscription_plan: '',
    subscription_status: '',
    status: '',
    verification_status: '',
    start_date: '',
    end_date: '',
    country: '',
    province: '',
    city: ''
  };
  const [firstLoadDone, setFirstLoadDone] = useState(false);
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const planNameMap = {
    attendance_yearly: "Attendance Yearly",
    attendance_monthly: "Attendance Monthly",
    full_monthly: "Full Monthly",
    full_yearly: "Full Yearly",
  };
  // console.log(token)
  // Move formatRange to top-level so it's available in render
  const formatRange = (start, end) => {
    if (!start && !end) return "-";
    const format = (d) => d ? convertUTCToLocalDateTime(d, { formatOptions: { day: '2-digit', month: 'short', year: 'numeric' } }) : "-";
    return `${format(start)} - ${format(end)}`;
  };

  const fetchData = async (
    isSorting = false,
    keyword = '',
    appliedFilters = {}
  ) => {
    const isInitialLoad = !firstLoadDone;

    if (isInitialLoad) {
      setLoading(true);
    } else {
      setTableProcessing(true);
    }

    const queryParams = new URLSearchParams({
      page: page + 1,
      limit: 6,
      sort_by: sortConfig.key || 'email',
      sort_order: sortConfig.direction?.toUpperCase() || 'DESC',
      status: appliedFilters.status || 'invited',
    });

    if (keyword) {
      queryParams.append('search', keyword);
    }
    if (appliedFilters.subscription_plan) {
      queryParams.append('subscription_plan', appliedFilters.subscription_plan);
    }

    if (appliedFilters.subscription_status) {
      queryParams.append('subscription_status', appliedFilters.subscription_status);
    }

    if (appliedFilters.status && appliedFilters.status !== 'all') {
      queryParams.append('status', appliedFilters.status);
    }

    if (appliedFilters.verification_status && appliedFilters.verification_status !== 'all') {
      queryParams.append('verification_status', appliedFilters.verification_status);
    }

    if (appliedFilters.start_date) {
      queryParams.append('start_date', appliedFilters.start_date);
    }
    if (appliedFilters.end_date) {
      queryParams.append('end_date', appliedFilters.end_date);
    }
    if (appliedFilters.country) {
      queryParams.append("country", appliedFilters.country);
    }
    if (appliedFilters.province) {
      queryParams.append("state", appliedFilters.province); // backend expects state
    }
    if (appliedFilters.city) {
      queryParams.append("city", appliedFilters.city);
    }
    if (appliedFilters.trial_end_date_from) {
      queryParams.append(
        "trial_end_date_from",
        appliedFilters.trial_end_date_from
      );
    }

    if (appliedFilters.trial_end_date_to) {
      queryParams.append(
        "trial_end_date_to",
        appliedFilters.trial_end_date_to
      );
    }

    if (appliedFilters.subscription_start_date_from) {
      queryParams.append(
        "subscription_start_date_from",
        appliedFilters.subscription_start_date_from
      );
    }

    if (appliedFilters.subscription_start_date_to) {
      queryParams.append(
        "subscription_start_date_to",
        appliedFilters.subscription_start_date_to
      );
    }
    const url = `${BASE_URL}/company-admins?${queryParams.toString()}`;
    console.log("📡 Final Invited API URL:", url);

    try {
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await res.json();
      if (json.error === false) {
        let admins = json.data.company_admins;

        if (appliedFilters.subscription_plan) {
          admins = admins.filter(
            (item) =>
              item.subscription_plan &&
              item.subscription_plan.toLowerCase() === appliedFilters.subscription_plan.toLowerCase()
          );
        }
        // formatRange now defined at top-level
        const formatted = json.data.company_admins.map((item) => ({
          id: item.id,
          admin: item.full_name,
          email: item.email,
          company: item.company_name,
          country: item.country,
          subscription: planNameMap[item.subscription_plan] || item.subscription_plan,
          subscriptionStatus: item.subscription_status,
          status: item.status,
          verificationStatus: item.verification_status,
          active: item.current_employees,
          subscriptionPeriod: { start: item.subscription_start_date, end: item.subscription_end_date },
          trialPeriod: { start: item.trial_start_date, end: item.trial_end_date },
          Users: item.max_employees,
          businessEmail: item.business_email,
          date: item.created_at,
          subscriptionDate: item.trial_end_date,
        }));

        setTableRows(formatted);
        setTotalPages(json.data.pagination.pages);
        dispatch(setCompanyAdmins(json.data.company_admins));
      } else {
        toast.error('Failed to fetch data');
      }
    } catch (err) {
      toast.error('Error fetching data');
      console.error("❌ API fetch error:", err);
    } finally {
      // if (isSorting) {
      //   setSortLoading(false);
      // } else {
      //   setLoading(false);
      //     setTableProcessing(false); 
      // }
      setLoading(false);
      setTableProcessing(false);
      setFirstLoadDone(true);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData(false, searchTerm, filters);
    }, 500);
    return () => clearTimeout(delay);
  }, [page, filters, searchTerm]);

  const HaederStyles = {
    color: '#44546F',
    fontSize: '12px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,
    textAlign: "center"
  };
  const DataStyles = {
    color: '#172B4D',
    fontSize: '12px',
    textAlign: "center"
    ,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    // textAlign:"center",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // padding: '4px 6px' 
  };
  const isFilterApplied = Object.values(filters).some(f => f && f !== '');

  const isMobile = useMediaQuery('(max-width:768px)');
  const statusButtonStyles = {
    verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
    active: { backgroundColor: '#4BCE97', color: '#164B35' },
    inactive: { backgroundColor: ' #F87168', color: '#5D1F1A' },
    blocked: { backgroundColor: '#F87168', color: '#5D1F1A' },
    rejected: { backgroundColor: '#D32F2F', color: '#FFFFFF' },
    requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    invited: { backgroundColor: '#579DFF', color: '#09326C' },
    pending: { backgroundColor: '#F5CD47', color: '#533F04' },
  };

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  const countryCodeToName = {}
  countryList().getData().forEach((c) => {
    countryCodeToName[c.value] = c.label
  })
  const statusValues = ['active', 'inactive', 'invited', 'requested'];

  const statusOptions = statusValues.map((value) => ({
    label: t(`statusOptions.${value}`),
    value,
  }));
  // const statusOptions = [
  //   { label: 'Active', value: 'active' },
  //   { label: 'Inactive', value: 'inactive' },
  //   { label: 'Invited', value: 'invited' },
  //   { label: 'Requested', value: 'requested' },
  // ];
  const handleStatusUpdate = async (status) => {
    if (selected.length === 0) {
      console.warn("❗ No rows selected.");
      return;
    }
    setStatusUpdating(status);
    const payload = {
      company_admin_ids: selected,
      status: status, // valid values only
      verification_status: 'verified',
    };
    const url = `${BASE_URL}/company-admins/status`;

    console.log("🚀 PUT to:", url);
    console.log("📦 Payload:", payload);

    try {
      const res = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      console.log("📬 HTTP Status:", res.status);
      const result = await res.json();
      console.log("🧾 Response:", result);

      if (result.error === false) {
        toast.success(`Status updated to "${status}"`);

        const updated = tableRows.map((row) =>
          selected.includes(row.id)
            ? { ...row, status }
            : row
        );

        setTableRows(updated);
        setSelected([]);
      } else {
        toast.error(result.message || 'Failed to update status');
        console.log(result.message)
      }
    } catch (err) {
      console.error("❌ Error in request:", err);
      toast.error('Something went wrong while updating.');
    }
    finally {
      setStatusUpdating(null);
    }
  };
  const columns = [
    { key: 'id', label: t('invites.columns.id') },
    { key: 'admin', label: t('invites.columns.admin') },
    { key: 'company', label: t('invites.columns.company') },

    { key: 'email', label: t('invites.columns.email') },
    { key: 'country', label: t('invites.columns.country') },
    { key: 'active', label: t("activeUsers") },

    { key: 'Users', label: t("maxUsers") },

    { key: 'subscription', label: t('subscriptionPlan') },
    { key: 'subscriptionStatus', label: t('subscriptionStatus') },
    { key: 'status', label: t('invites.columns.status') },
    { key: 'verificationStatus', label: t("invites.columns.verificationStatus") },
    { key: 'date', label: t('DateTime') },
    { key: 'subscriptionPeriod', label: t("subscriptionPeriod") },
    { key: 'trialPeriod', label: t("trialPeriod") },
    { key: 'action', label: t('invites.columns.action') },

  ];
  const handleSort = (columnKey) => {
    const direction =
      sortConfig.key === columnKey && sortConfig.direction === 'asc'
        ? 'desc'
        : 'asc';
    setSortConfig({ key: columnKey, direction });
    fetchData(true);
  };
  const allSelected = tableRows.length > 0 && selected.length === tableRows.length;
  const isIndeterminate = selected.length > 0 && !allSelected;


  const handleVerificationStatusUpdate = async (verificationStatus, id) => {
    if (!id) {
      toast.error("No ID selected.");
      return;
    }
    setVerifyingId(id);
    const payload = {
      company_admin_ids: [id],
      status: tableRows.find(row => row.id === id)?.status || 'pending', // keep current status
      verification_status: verificationStatus,
    };

    const url = `${BASE_URL}/company-admins/status`;

    try {
      const res = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result.error === false) {
        toast.success(`Verification status updated to "${verificationStatus}"`);

        const updated = [...tableRows];
        const index = updated.findIndex(row => row.id === id);
        if (index !== -1) {
          updated[index].verificationStatus = verificationStatus;
          setTableRows(updated);
        }
      } else {
        toast.error(result.message || "Failed to update verification status");
      }
    } catch (err) {
      console.error("❌ Error in verification update:", err);
      toast.error("Something went wrong while updating verification status.");
    }
    finally {
      setVerifyingId(null); // End loader
    }
  };

  const menuAnchorsRef = useRef({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);


  const handleViewClick = async () => {
    if (!menuRowId) return;

    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/company-admins/${menuRowId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await res.json();
      console.log("👁️ View Details Response:", json);
      if (!json.error && json.data?.company_admin) {
        setSelectedRow(json.data.company_admin);
      } else {
        toast.error("Failed to fetch company admin details");
      }
    } catch (err) {
      toast.error("Error fetching details");
    } finally {
      setLoading(false);
      setAnchorEl(null); // close menu
    }
  };

  const handleMessagesClick = () => {
    if (!menuRowId) return;

    const selectedCompanyAdmin = tableRows.find(row => row.id === menuRowId);
    console.log("📧 Opening messages for company admin:", selectedCompanyAdmin);
    if (selectedCompanyAdmin) {
      const navigationState = {
        openChatWith: {
          id: selectedCompanyAdmin.id,
          name: selectedCompanyAdmin.admin,
          email: selectedCompanyAdmin.email,
        },
        chatType: 'company_admin'
      };
      console.log("📤 Navigating with state:", navigationState);
      navigate('/messages', { state: navigationState });
    }
    setAnchorEl(null);
  };


  // true if any filter set

  const clearFilters = () => {
    setFilters(INITIAL_FILTERS);
    setPage(0);
  };


  const fetchAllInvitedCompanies = async () => {
    const queryParams = new URLSearchParams({
      no_pagination: "true",
      status: filters.status || "invited",
      sort_by: sortConfig.key || "created_at",
      sort_order: sortConfig.direction?.toUpperCase() || "DESC",
    });

    if (searchTerm) queryParams.append("search", searchTerm);

    if (filters.subscription_plan) {
      queryParams.append("subscription_plan", filters.subscription_plan);
    }
    if (filters.subscription_status) {
      queryParams.append("subscription_status", filters.subscription_status);
    }
    if (filters.start_date) {
      queryParams.append("start_date", filters.start_date);
    }
    if (filters.end_date) {
      queryParams.append("end_date", filters.end_date);
    }
    if (filters.country) {
      queryParams.append("country", filters.country);
    }
    if (filters.province) {
      queryParams.append("state", filters.province); // backend expects state
    }
    if (filters.city) {
      queryParams.append("city", filters.city);
    }
    if (filters.trial_end_date_from)
      queryParams.append("trial_end_date_from", filters.trial_end_date_from);

    if (filters.trial_end_date_to)
      queryParams.append("trial_end_date_to", filters.trial_end_date_to);

    if (filters.subscription_start_date_from)
      queryParams.append("subscription_start_date_from", filters.subscription_start_date_from);

    if (filters.subscription_start_date_to)
      queryParams.append("subscription_start_date_to", filters.subscription_start_date_to);
    const url = `${BASE_URL}/company-admins?${queryParams.toString()}`;
    try {
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();

      if (json.error) {
        toast.error(json.message || "Failed to fetch invites");
        return [];
      }

      return (json.data?.company_admins || []).map((item) => ({
        id: item.id,
        admin: item.full_name,
        email: item.email,
        company: item.company_name,
        country: item.country,
        subscription: item.subscription_plan,
        status: item.status,
        verificationStatus: item.verification_status,
        date: new Date(item.created_at).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      }));
    } catch (err) {
      console.error("❌ Fetch all invited error:", err);
      toast.error("Something went wrong fetching invites.");
      return [];
    }
  };
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);

  const handleStatusUpdateSingle = async (id, status) => {
    const payload = {
      company_admin_ids: [id],
      status,
      verification_status: 'verified',
    };

    try {
      const res = await fetch(`${BASE_URL}/company-admins/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (!result.error) {
        toast.success(`Status updated to "${status}"`);
      } else {
        toast.error(result.message || "Failed to update status");
      }

    } catch (err) {
      console.error("❌ Single update error:", err);
      toast.error("Something went wrong while updating status.");
    }
  };

  const getStatusConfig = (currentStatus) => {
    switch (currentStatus?.toLowerCase()) {
      case "active":
        return {
          showError: true,
          options: ["Inactive"],          // ✅ no options
          showArrow: false,     // ✅ lock dropdown
        };

      case "invited":
        return {
          showError: true,
          options: ["Active", "Inactive"],
          showArrow: true,
        };

      case "requested":
        return {
          showError: true,
          options: ["Active", "Inactive"],
          showArrow: true,
        };

      case "inactive":
        return {
          showError: true,
          options: ["Active"],
          showArrow: true,
        };

      default:
        return {
          showError: true,
          options: [],
          showArrow: false,
        };
    }
  };

  const getVerificationConfig = (currentStatus) => {
    switch (currentStatus?.toLowerCase()) {
      case "pending":
        return {
          showArrow: true,
          options: ["verified", "rejected"],
          disabled: false,
        };

      case "verified":
      case "rejected":
      default:
        return {
          showArrow: false,
          options: [],
          disabled: true, // ✅ important
        };
    }
  };


  const mapFilters = {
    verification_status: filters.verification_status,
    start_date: filters.start_date,
    end_date: filters.end_date,
    trial_end_date_from: filters.trial_end_date_from,
    trial_end_date_to: filters.trial_end_date_to,

    subscription_start_date_from: filters.subscription_start_date_from,
    subscription_start_date_to: filters.subscription_start_date_to,
    // state: filters.state || "",   // if you add state later
    country: filters.country,
    state: filters.province,
    city: filters.city,
    subscription_status: filters.subscription_status,

  };

  return (
    <>

      <Box sx={{ py: 2, px: 1 }}>


        {fromDashboard && !selectedRow && (
          <Box
            sx={{
              border: '1px solid #E4E6EF',
              borderRadius: 2,
              px: 2,
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              minHeight: 55,
              mb: 2
            }}
          >
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
              onClick={() => navigate(-1)}
            >
              <img src={back} style={{ width: 30, height: 30 }} />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: '14px',
                  color: '#626F86',
                  textAlign: 'center'
                }}
              >
                {t('clientsTrialDetails.back')}
              </CustomText>
            </Box>
          </Box>
        )}

        <Toaster />
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 'calc(100vh - 120px)',

            }}
          >
            <CircularProgress sx={{ color: '#006EC2' }} size={40} thickness={4} />
          </Box>
        ) : selectedRow ? (
          <InviteDetails selectedRow={selectedRow} onClose={() => setSelectedRow(null)} />
        ) : (
          <>

            <Box sx={{ mb: 2, }}>
              <InvitedClientsPins selectedClientId={selectedClientId}
                onClearClientId={() => setSelectedClientId(null)}
                filters={mapFilters}
                page={page}
                limit={6}
                search={searchTerm}
              />
            </Box>

            <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 2, border: '1px solid #E4E6EF' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  px: 2,
                  mb: 2,
                  flexWrap: 'wrap',
                  rowGap: 1,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontWeight: 600,
                      fontSize: '18px',
                      color: '#003149',
                    }}
                  >
                    {t('invites.manageTitle')}
                  </CustomText>

                  {tableProcessing && (
                    <CircularProgress
                      size={18}
                      thickness={4}
                      sx={{ color: '#006EC2' }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    flexWrap: 'wrap',
                    flexGrow: 1,
                    justifyContent: selected.length === 0 ? 'center' : 'flex-end',
                  }}
                >
                  {selected.length > 0
                    ? statusOptions.map(({ label, value }) => (
                      <Button
                        key={label}
                        onClick={() => handleStatusUpdate(value)}
                        variant="contained"
                        size="small"
                        sx={{
                          px: 2,
                          height: 34,
                          fontSize: 13,
                          fontWeight: 400,
                          fontFamily: 'Poppins, sans-serif',
                          borderRadius: '4px',
                          textTransform: 'none',
                          backgroundColor: statusButtonStyles[value]?.backgroundColor,
                          color: statusButtonStyles[value]?.color,
                          '&:hover': {
                            backgroundColor: statusButtonStyles[value]?.backgroundColor,
                            opacity: 0.9,
                          },
                        }}
                      >
                        {statusUpdating === value && (
                          <CircularProgress
                            size={16}
                            thickness={4}
                            sx={{ color: statusButtonStyles[value]?.color, mr: 1 }}
                          />
                        )}
                        {label}
                      </Button>
                    ))
                    : (
                      <>
                        <Box
                          sx={{
                            mx: 'auto',
                            px: 0.5,
                            py: 0.2,
                            borderRadius: 1,
                            height: 34,
                            border: '2px solid #091E4224',
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: 250,
                          }}
                        >
                          <InputBase
                            placeholder={t('adminNameEmail')}
                            value={searchTerm}
                            onChange={(e) => {
                              setSearchTerm(e.target.value);
                              setPage(0);
                            }}
                            sx={{
                              ml: 0.5, fontSize: 15, letterSpacing: '0px',
                              fontFamily: 'Poppins, sans-serif',
                              color: '#939393', fontWeight: 400, width: '100%'
                            }}
                          />
                          <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
                        </Box>
                        <ExportDropdown
                          onDownloadPDF={async () => {
                            const allData = await fetchAllInvitedCompanies(); // 👈 now fetches filtered + full
                            const blobStream = pdf(<ExportInvitesPDF data={allData} />).toBlob();
                            blobStream.then((blob) => {
                              const link = document.createElement("a");
                              link.href = URL.createObjectURL(blob);
                              link.download = `Manage_Invites_${new Date()
                                .toISOString()
                                .slice(0, 10)}.pdf`;
                              link.click();
                            });
                          }}
                          onDownloadExcel={async () => {
                            const allData = await fetchAllInvitedCompanies(); // 👈 now fetches filtered + full
                            ExportInvitesExcel(allData);
                          }}
                        />
                        <Button
                          onClick={() => setOpenDrawer(true)}
                          variant="contained"
                          size="small"
                          sx={{
                            px: 2,
                            backgroundColor: '#006EC2',
                            height: 32,
                            fontSize: 14,
                            fontWeight: 400,
                            fontFamily: 'Poppins, sans-serif',
                            borderRadius: '4px',
                            textTransform: 'none',
                          }}
                          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
                        >
                          {t('invites.add')}
                        </Button>


                        {isFilterApplied ? (
                          <Box
                            sx={{
                              position: "relative",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 34,
                              height: 34,
                              borderRadius: 1,
                              bgcolor: "#006EC2", // blue background when applied
                            }}
                          >
                            {/* Filter Icon */}
                            <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

                            {/* Small Cross at top-right */}
                            <IconButton
                              size="small"
                              onClick={clearFilters} // your clear handler
                              sx={{
                                position: "absolute",
                                top: -6,
                                right: -6,
                                bgcolor: "white",
                                width: 18,
                                height: 18,
                                border: "1px solid #C4C4C4",
                                "&:hover": { bgcolor: "#f5f5f5" },
                              }}
                            >
                              <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
                            </IconButton>
                          </Box>
                        ) : (
                          <IconButton
                            onClick={() => setFilterDrawerOpen(true)}
                            sx={{
                              border: "1px solid #C4C4C4",
                              borderRadius: 1,
                              width: 34,
                              height: 34,
                              backgroundColor: "white",
                              color: "#5E5C5C",
                              "&:hover": { backgroundColor: "#F2F2F2" },
                            }}
                          >
                            <FilterAltIcon sx={{ fontSize: 22 }} />
                          </IconButton>
                        )}
                      </>
                    )}
                </Box>
              </Box>
              <Box>
                <Box
                  sx={{
                    width: '100%',
                    overflowX: 'auto',
                    // display: 'block', // ⬅️ Ensure it's not flex
                    paddingBottom: 1,
                  }}
                >
                  <Box sx={{}}>
                    <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                      <Table
                        size="small"
                        sx={{
                          minWidth: 'max-content', // ✅ Let table expand beyond container
                          tableLayout: 'auto',
                        }}
                      >
                        <TableHead sx={{
                          whiteSpace: 'nowrap', // ✅ Prevent text wrap
                          // overflow: 'hidden',
                          // textOverflow: 'ellipsis'
                        }}>

                          <TableRow>

                            {columns.map((col, index) => (
                              <TableCell
                                key={col.key}
                                sx={{
                                  ...HaederStyles, py: '6px', px: '0px',
                                  pl: index === 0 ? 2 : 0,
                                  width:
                                    index === 0 ? '80px' :
                                      index === 1 ? '150px' :
                                        index === 2 ? '180px' :
                                          index === 3 ? '180px' :
                                            index === 4 ? '150px' :
                                              index === 5 ? '70px' :
                                                index === 6 ? '150px' :
                                                  index === 7 ? '160px' :
                                                    index === 8 ? '200px' :
                                                      index === 9 ? '100px' :
                                                        '100px'
                                }}

                              >

                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'center',   // <-- centers the whole header content
                                    alignItems: 'center',
                                    gap: 0,
                                    width: "100%",              // <-- needed to truly center
                                    cursor: col.key !== 'action' ? 'pointer' : 'default'
                                  }}
                                  onClick={() => col.key !== 'action' && handleSort(col.key)}
                                >
                                  <span style={{ flexShrink: 0 }}>{col.label}</span>

                                  {col.key !== 'action' && (
                                    sortConfig.key === col.key ? (
                                      sortConfig.direction === 'asc'
                                        ? <NorthIcon sx={{ fontSize: '12px' }} />
                                        : <SouthIcon sx={{ fontSize: '12px' }} />
                                    ) : (
                                      <SouthIcon sx={{ fontSize: '12px' }} />
                                    )
                                  )}
                                </Box>

                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tableRows.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={columns.length + 1}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: 300,
                                  }}
                                >
                                  <img src={emptyscreen} alt="No Data" style={{ width: 200 }} />
                                  <CustomText
                                    sx={{
                                      ...textStyles.h1,
                                      fontWeight: 500,
                                      fontSize: "16px",
                                      color: "#003149",
                                      pt: 1,
                                    }}
                                  >
                                    {t("empty.no_user")}
                                  </CustomText>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ) : (
                            tableRows
                              .map((row, index) => {
                                const { showError, options } = getStatusConfig(row.status);
                                const {
                                  showArrow: verificationShowArrow,
                                  options: verificationOptions,
                                  disabled: verificationDisabled,
                                } = getVerificationConfig(row.verificationStatus);

                                return (
                                  <TableRow
                                    key={row.id}
                                    hover
                                    onClick={() => setSelectedClientId(row.id)}
                                    sx={{ cursor: "pointer" }}
                                  >
                                    <TableCell sx={{ ...DataStyles, pl: 2, width: 80 }}>
                                      {row.id}
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 250 }}>
                                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                                        <CustomText sx={{ fontSize: 14, fontWeight: 500, color: "#172B4D" }}>
                                          {row.admin || "-- "}
                                        </CustomText>
                                        <CustomText sx={{ fontSize: 13, color: "#5A5A5A" }}>
                                          {row.email || "-- "}
                                        </CustomText>
                                      </Box>
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 180 }}>
                                      {row.company || "-- "}
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 180 }}>
                                      {row.businessEmail || "-- "}
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 150 }}>
                                      {countryCodeToName[row.country] || row.country || "-- "}
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 150 }}>
                                      {row.active || "-- "}
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 150 }}>
                                      {row.Users || "-- "}
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 120 }}>
                                      {Array.isArray(row.subscription)
                                        ? row.subscription.join(", ")
                                        : String(row.subscription).replace(/[\[\]{}"]/g, "")}
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 120, textTransform: "capitalize" }}>
                                      {(row.subscriptionStatus || "-- ").replace(/_/g, " ")}
                                    </TableCell>
                                    {/* STATUS */}
                                    <TableCell sx={{ ...DataStyles, width: 160, textAlign: "center" }}>
                                      <Box
                                        sx={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 1,
                                          px: 0.6,
                                          py: 0.1,
                                          borderRadius: 1,
                                          backgroundColor:
                                            statusButtonStyles[row.status]?.backgroundColor,
                                          color: statusButtonStyles[row.status]?.color,
                                        }}
                                      >
                                        {statusUpdatingId === row.id && (
                                          <CircularProgress
                                            size={12}
                                            thickness={4}
                                            sx={{
                                              color:
                                                statusButtonStyles[row.status]?.color || "#333",
                                            }}
                                          />
                                        )}

                                        <StatusDropdown
                                          currentStatus={row.status}
                                          showArrow={true}
                                          showError={showError}
                                          statusOptions={options}
                                          onChange={(newStatus) => {
                                            setStatusUpdatingId(row.id);

                                            const updated = [...tableRows];
                                            updated[index].status = newStatus;
                                            setTableRows(updated);

                                            handleStatusUpdateSingle(
                                              row.id,
                                              newStatus.toLowerCase()
                                            ).finally(() => setStatusUpdatingId(null));
                                          }}
                                        />
                                      </Box>
                                    </TableCell>

                                    {/* VERIFICATION */}
                                    <TableCell sx={{ ...DataStyles, width: 160, textAlign: "center" }}>
                                      <Box
                                        sx={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 1,
                                          px: 0.6,
                                          py: 0.1,
                                          borderRadius: 1,
                                          backgroundColor:
                                            statusButtonStyles[row.verificationStatus]
                                              ?.backgroundColor || "#E0E0E0",
                                          color:
                                            statusButtonStyles[row.verificationStatus]?.color ||
                                            "#333",
                                          pointerEvents: verificationDisabled ? "none" : "auto", // ✅ FIX

                                        }}
                                      >
                                        {verifyingId === row.id && (
                                          <CircularProgress size={12} thickness={4} />
                                        )}

                                        <ArrowStatusDropdown
                                          currentStatus={row.verificationStatus}
                                          onChange={(newStatus) =>
                                            handleVerificationStatusUpdate(newStatus, row.id)
                                          }
                                          statusOptions={verificationOptions}   // ✅ controlled options
                                          showArrow={verificationShowArrow}     // ✅ arrow only for pending
                                        />
                                      </Box>
                                    </TableCell>

                                    <TableCell sx={{ ...DataStyles, width: 200 }}>
                                      {row.date ? convertUTCToLocalDateTime(row.date) : "-"}
                                    </TableCell>


                                    <TableCell sx={{ ...DataStyles, width: 220 }}>
                                      {formatRange(row.subscriptionPeriod.start, row.subscriptionPeriod.end)}
                                    </TableCell>
                                    <TableCell sx={{ ...DataStyles, width: 220 }}>
                                      {formatRange(row.trialPeriod.start, row.trialPeriod.end)}
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }}>
                                      <IconButton
                                        ref={(el) => {
                                          if (el) menuAnchorsRef.current[row.id] = el;
                                        }}
                                        onClick={() => {
                                          setAnchorEl(menuAnchorsRef.current[row.id]);
                                          setMenuRowId(row.id);
                                        }}
                                      >
                                        <MoreVertIcon fontSize="small" sx={{ fontSize: 22 }} />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                          )}
                        </TableBody>



                      </Table>
                    </TableContainer>
                    <Menu
                      sx={{ fontSize: "15px", boxShadow: "none" }}
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => setAnchorEl(null)}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                      PaperProps={{
                        sx: {
                          // minWidth: 80,
                          // paddingY: 0.5,
                          // boxShadow:"none",
                          // border: '1px solid #E0E0E0',
                        },
                      }}
                      MenuListProps={{
                        sx: {
                          paddingY: 0,
                        },
                      }}
                    >
                      <MenuItem onClick={handleViewClick} sx={{
                        fontSize: "14px",
                        fontFamily: 'Poppins, sans-serif',
                      }}>{t("common.view")}</MenuItem>
                      <MenuItem onClick={handleMessagesClick} sx={{
                        fontSize: "14px",
                        fontFamily: 'Poppins, sans-serif',
                      }}>{t("messages")}</MenuItem>

                    </Menu>
                  </Box>
                </Box>

              </Box>

              <Box sx={{ display: 'flex', flexWrap: "wrap", justifyContent: 'center', mt: 2 }}>
                <Pagination
                  count={totalPages}
                  page={page + 1}
                  onChange={(e, value) => setPage(value - 1)}
                  shape="rounded"
                  color="primary"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: 13,
                      fontWeight: 500,
                    },
                    '& .Mui-selected': {
                      backgroundColor: '#E9F3FF',
                      color: '#006EC2',
                    },
                  }}
                />
              </Box>
            </Box>
          </>
        )}


        <AddCompanyDrawer open={openDrawer} onClose={() => setOpenDrawer(false)}
          onSuccess={() => {
            setOpenDrawer(false);
            fetchData();    // <- Refetch the table data!
          }} />
        <FilterDrawer
          open={filterDrawerOpen}
          onClose={() => setFilterDrawerOpen(false)}
          filters={filters}
          setFilters={setFilters}
          onApplyFilters={(updatedFilters) => {
            console.log("📤 Filters applied:", updatedFilters);
            setFilters(updatedFilters);
            setPage(0);
            setFilterDrawerOpen(false);
          }}
        />
      </Box>
    </>

  );
};

export default ManageInvitesTable;














































